import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  const colorMap: Record<string, string> = {
    romance: 'bg-primary-50 text-primary-700',
    fantasy: 'bg-accent-50 text-accent-700',
    action: 'bg-red-50 text-red-700',
    drama: 'bg-secondary-50 text-secondary-700',
    comedy: 'bg-amber-50 text-amber-700',
    thriller: 'bg-slate-100 text-slate-700',
    daily: 'bg-emerald-50 text-emerald-700',
    historical: 'bg-rose-50 text-rose-700',
    school: 'bg-sky-50 text-sky-700',
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            按类型快速找到你喜欢的韩漫作品，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex flex-col items-center gap-3 p-5 rounded-lg cursor-pointer transition-all duration-300 hover:scale-105 ${colorMap[cat.slug] || 'bg-background-200 text-foreground-700'}`}
            >
              <div className="w-12 h-12 flex items-center justify-center">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <span className="text-sm font-medium whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}